import Helper from './Helper';

class Video {
  constructor() {
    const videos = Array.prototype.slice.call(document.querySelectorAll('.ns-video'));

    videos.forEach(video => {
      const thumbnail = video.querySelector('.ns-video__thumbnail');
      const videoElement = video.querySelector('.ns-video__video');

      if (!!videoElement && !!thumbnail) {
        thumbnail.addEventListener('click', () => {
          try {
            let videoPlayer = videoElement.querySelector('video');
            videoPlayer.play();
            thumbnail.classList.add('fade-out');
            thumbnail.style.display = 'none';
          } catch (err) {
            alert("Video URL ist fehlerhaft: " + url);
            console.log(err);
          }
        });
      } else {
        thumbnail.addEventListener('click', () => {
          alert("Video URL ist fehlerhaft: " + url);
        });
      }


    });
  }
}

export default Video;
